import React, { Component } from "react"
import GoogleMapReact from "google-map-react"
import { FaPizzaSlice } from "react-icons/fa"

import styled from "styled-components"

const MapMarker = styled(FaPizzaSlice)`
  font-size: 30px;
  color: #e50022;
`

const AnyReactComponent = () => <MapMarker />

class Map extends Component {
  static defaultProps = {
    center: {
      lat: 31,
      lng: -95,
    },
    zoom: 6,
  }

  render() {
    return (
      // <StaticQuery
      //   query={graphql`
      //     query LocationQuery {
      //       location: allSanityMain {
      //         nodes {
      //           address
      //           email
      //           phone
      //           state
      //           zip
      //           city
      //           latitude
      //           longitude
      //         }
      //       }
      //     }
      //   `}
      //   render={data => {
      //     const {
      //       latitude,
      //       longitude,
      //       address,
      //       city,
      //       state,
      //       zip,
      //     } = data.location.nodes[0]

      //     const centerMap = { lat: Number(latitude), lng: Number(longitude) }

      //     return (
      //       <div>
      //         <div>
      //           <u>Physical Address:</u>
      //           {latitude}
      //         </div>
      //         <div
      //           style={{
      //             height: "400px",
      //             width: "100%",
      //           }}
      //         >
      //           <GoogleMapReact
      //             bootstrapURLKeys={{
      //               key: "AIzaSyBz-mGDd-xPIHE1ciDvAYz7t2jvKIceq9s",
      //               v: "3.32",
      //             }}
      //             defaultCenter={centerMap}
      //             defaultZoom={this.props.zoom}
      //           >
      //             <AnyReactComponent lat={latitude} lng={longitude} />
      //           </GoogleMapReact>
      //         </div>
      //       </div>
      //     )
      //   }}
      // />

      <div
        style={{
          height: "400px",
          width: "100%",
        }}
      >
        <GoogleMapReact
          bootstrapURLKeys={{
            key: "AIzaSyAPtVIICZwr8HtRpizVX4BqXE4x8WBRtCE",
            v: "3.32",
          }}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
        >
          {this.props.locations.map(l => (
            <AnyReactComponent lat={l.latitude} lng={l.longitude} />
          ))}
        </GoogleMapReact>
      </div>
    )
  }
}

export default Map
